import { withFormik } from "formik";
import * as Yup from "yup";

const loginEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email("The email you have entered is invalid")
      .max(60, "Max length of 60 characters")
      .trim()
      .required("Please enter email"),
    password: Yup.string()
      .required("Please enter password")
      .min(8, "Password must be of at least 8 characters in length")
  }),
  mapPropsToValues: props => ({
    email: "",
    password: ""
  }),
  validateOnMount: true,
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default loginEnhancer;
